
export class Candidate {
    _id: string;
    id: string;
    name: string;
    email: string;
    phone: string;
    address: string;
    jobopening: string;
    experience: number;
    notes:string;
    admin_notes:string;
    tagging:string;
}